module.exports = __webpack_public_path__ + "img/8.3a21a905.jpg";